import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Col, Container, Navbar, Row } from 'react-bootstrap';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useDarknetIdentity } from '../contexts/IdentityContext';
import { useDarknetSocket } from '../contexts/SocketContext';
import CustomTooltip from './common/CustomTooltip';

import logoIcon from "../styles/images/darknet-logo-blue.png";
import twitterIcon from "../styles/images/twitter-white.png";
import discordIcon from "../styles/images/discord-white.png";
import supportIcon from "../styles/images/question-white.png";
import profileIcon from '../styles/images/profile.png';
import gamesIcon from '../styles/images/games.png';
import pvpIcon from '../styles/images/pvp.png';
import gearIcon from '../styles/images/gear.png';
import rewardsIcon from '../styles/images/rewards.png';
import leaderboardIcon from '../styles/images/leaderboard.png';

const { version } = require('../../package.json');

export const Header = () => {
    return <Navbar bg="dark" className="dg-navbar" fixed='top'>
        <Container className="bg-dark py-2" fluid>
            <Row className="d-none d-md-contents">
                <Col md={4}></Col>
                <Col md={4} className="text-center text-light">
                    <span className="fs-2 ps-3">
                        Darknet <img src={logoIcon} alt="logo" width={64} className="logo" /> Games
                    </span>
                </Col>
                <Col md={4} className="text-end">
                    <WalletMultiButton />
                </Col>
            </Row>
            <Row className="d-block d-md-none w-100 mx-auto">
                <Col xs={12} className="text-center text-light">
                    <Link to="/" className="fs-2 ps-3 text-light">
                        <img src={logoIcon} alt="logo" width={48} className="logo" />
                        <br />
                        Darknet&nbsp;Games
                    </Link>
                </Col>
            </Row>
        </Container>
    </Navbar>
}

export const SubNavbar = () => {
    const { authenticated, identity } = useDarknetIdentity();
    const location = useLocation();

    return (<>
        <div className="d-none d-lg-block">
            <div className="dg-sidebar">
                <ul>
                    <li>
                        <CustomTooltip id={"sidebar-home"} title={"Home"} placement="right">
                            <Link to={'/'}>
                                <img src={logoIcon} alt="logo" className="dg-sidebar-icon" />
                            </Link>
                        </CustomTooltip>
                    </li>
                    {authenticated && (
                        <li>
                            <CustomTooltip id={"sidebar-profile"} title={"Profile"} placement="right">
                                <Link to={'/profile'} className={(location.pathname === '/profile') ? "selected" : ""}>
                                    <img src={profileIcon} alt="profile" className="dg-sidebar-icon" />
                                </Link>
                            </CustomTooltip>
                        </li>
                    )}
                    <li>
                        <CustomTooltip id={"sidebar-pvp"} title={"PVP"} placement="right">
                            <Link to={'/pvp'} className={(location.pathname === '/pvp') ? "selected" : ""}>
                                <img src={pvpIcon} alt="pvp" className="dg-sidebar-icon" />
                            </Link>
                        </CustomTooltip>
                    </li>
                    <li>
                        <CustomTooltip id={"sidebar-games"} title={"Library"} placement="right">
                            <Link to={'/games'} className={(location.pathname === '/games') ? "selected" : ""}>
                                <img src={gamesIcon} alt="games" className="dg-sidebar-icon" />
                            </Link>
                        </CustomTooltip>
                    </li>
                    <li>
                        <CustomTooltip id={"sidebar-rewards"} title={"Rewards"} placement="right">
                            <Link to={'/rewards'} className={(location.pathname === '/rewards') ? "selected" : ""}>
                                <img src={rewardsIcon} alt="rewards" className="dg-sidebar-icon" />
                            </Link>
                        </CustomTooltip>
                    </li>
                    <li>
                        <CustomTooltip id={"sidebar-leaderboards"} title={"Leaderboards"} placement="right">
                            <Link to={'/leaderboards'} className={(location.pathname === '/leaderboards') ? "selected" : ""}>
                                <img src={leaderboardIcon} alt="leaderboards" className="dg-sidebar-icon" />
                            </Link>
                        </CustomTooltip>
                    </li>
                </ul>
                <ul className="bottom-nav">
                    {authenticated && identity.account.name === "Shadow386" && (
                        <li>
                            <CustomTooltip id={"sidebar-admin"} title={"Admin"} placement="right">
                                <Link to={'/admin'} className={(location.pathname === '/admin') ? "selected" : ""}>
                                    <img src={gearIcon} alt="profile" className="dg-sidebar-icon" />
                                </Link>
                            </CustomTooltip>
                        </li>
                    )}
                    <li>
                        <CustomTooltip id={"navbar-twitter"} title={"Twitter"} placement="right">
                            <a href="https://twitter.com/antisocialsjpeg" target="_blank" rel="noreferrer noopener" title="Twitter">
                                <img src={twitterIcon} alt="twitter" className="dg-navbar-icon" height={32} />
                            </a>
                        </CustomTooltip>
                    </li>
                    <li>
                        <CustomTooltip id={"navbar-discord"} title={"Discord"} placement="right">
                            <a href="https://discord.gg/antisocialsjpeg" target="_blank" rel="noreferrer noopener" title="Discord">
                                <img src={discordIcon} alt="discord" className="dg-navbar-icon" height={32} />
                            </a>
                        </CustomTooltip>
                    </li>
                    <li>
                        <CustomTooltip id={"navbar-support"} title={"Support"} placement="right">
                            <a href="https://discord.com/channels/1052954601755787386/1054738635502665839" target="_blank" rel="noreferrer noopener" title="Support">
                                <img src={supportIcon} alt="support" className="dg-navbar-icon" height={32} />
                            </a>
                        </CustomTooltip>
                    </li>
                </ul>
            </div>
        </div>
        <div className="d-block d-lg-none">
            <div className="dg-subnav">
                <Row className="justify-content-center g-0">
                    <Col>
                        <Link to={'/pvp'} className={(location.pathname === '/pvp') ? "selected" : ""}>
                            <img src={pvpIcon} alt="pvp" className="dg-sidebar-icon" />
                        </Link>
                    </Col>
                    <Col>
                        <Link to={'/games'} className={(location.pathname === '/games') ? "selected" : ""}>
                            <img src={gamesIcon} alt="games" className="dg-sidebar-icon" />
                        </Link>
                    </Col>
                    <Col>
                        <Link to={'/rewards'} className={(location.pathname === '/rewards') ? "selected" : ""}>
                            <img src={rewardsIcon} alt="rewards" className="dg-sidebar-icon" />
                        </Link>
                    </Col>
                    <Col>
                        <Link to={'/leaderboards'} className={(location.pathname === '/leaderboards') ? "selected" : ""}>
                            <img src={leaderboardIcon} alt="leaderboards" className="dg-sidebar-icon" />
                        </Link>
                    </Col>
                    {authenticated && (
                        <Col>
                            <Link to={'/profile'} className={(location.pathname === '/profile') ? "selected" : ""}>
                                <img src={profileIcon} alt="profile" className="dg-sidebar-icon" />
                            </Link>
                        </Col>
                    )}
                </Row>
            </div>
        </div>
    </>);
}

export const TokenTicker = () => {
    const script = document.createElement('script');
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
        "symbols": [
            {
                "proName": "BINANCE:BONKUSD",
                "title": "BONK/USD"
            },
            {
                "proName": "BINANCE:SOLUSD",
                "title": "SOL/USD"
            }
        ],
        "colorTheme": "dark",
        "isTransparent": false,
        "displayMode": "adaptive",
        "locale": "en"
    })
    document.getElementById("tradingview-widget-container")?.appendChild(script);
}

/*export const ReactHelmet = () => {
    let defaultSrc = "default-src 'self' https: wss: 'unsafe-inline'";
    let contentSrc = "connect-src wss: https: 'self' 'unsafe-inline' *";
    let imgSrc = "img-src data: blob: 'unsafe-inline' 'self' https:";
    let styleSrc = "style-src 'unsafe-inline' 'self' https:";
    let content = `${defaultSrc}; ${contentSrc}; ${imgSrc}; ${styleSrc};`;
    return (
        <Helmet>
            <meta http-equiv="Content-Security-Policy"
                content={content} />
        </Helmet>
    )
}*/

export const Footer = () => {
    const { socket } = useDarknetSocket();
    const [connected, setConnected] = useState(false);
    const [ping, setPing] = useState(0);

    useEffect(() => {
        socket.on('connect', () => { setConnected(true); });
        socket.on('disconnect', () => { setConnected(false); });

        return () => {
            socket.off('connect', () => { });
            socket.off('disconnect', () => { });
        }
    }, [socket]);

    useEffect(() => {
        if (connected) {
            setInterval(() => {
                let startTime = Date.now();
                socket.emit('ping', (response) => {
                    if (response?.success) {
                        setPing(Date.now() - startTime)
                    }
                });
            }, 1000);
        }
    }, [connected]);

    let ConnectedValue = () => {
        if (!connected) return (
            <CustomTooltip id={"footer-ping"} title={"Disconnected"} placement="right">
                <span className="text-danger"><del>0ms</del></span>
            </CustomTooltip>
        );
        if (ping >= 0 && ping < 100) return <span className="text-success">{ping.toString()}ms</span>
        if (ping >= 100 && ping < 200) return <span className="text-warning">{ping.toString()}ms</span>
        if (ping >= 200) return <span className="text-danger">{ping.toString()}ms</span>
        return <span className="text-danger">Error</span>
    }

    return <footer>
        <div className='connected fs-7 d-none d-md-block'>
            Ping: <ConnectedValue />
            <br />
            v{version}
            <br />
            <span className="font-normal">&copy;</span>&nbsp;{new Date().getFullYear()}
        </div>
    </footer>;
}
